const items = document.getElementsByClassName('faq-item');

for (let i = 0; i < items.length; i += 1) {

    const item = items[i];
    const transitionTime = 400; //todo: get from global var

    item.querySelector('.faq-question').addEventListener('click', function () {

        let faqOpenAnimationRunning = false;

        if(faqOpenAnimationRunning === false) {

            faqOpenAnimationRunning = true;

            const faqAnswer = item.querySelector('.faq-answer');

            // set height depending on faq-status
            if (item.classList.contains('faq-open')) {
                item.classList.remove('faq-open');
                faqAnswer.classList.remove('h-auto');
                setTimeout(function () {
                    faqAnswer.style.height = '0px';
                }, 50);

            } else {
                item.classList.add('faq-open');
                faqAnswer.style.height = faqAnswer.querySelector('.relative').offsetHeight + 'px';
            }

            setTimeout(function () {
                faqOpenAnimationRunning = true;
                if (item.classList.contains('faq-open')) {
                    faqAnswer.classList.add('h-auto');
                }
            }, transitionTime);

        }

    });
}
